"use strict";

exports.registerServiceWorker = function () {
  return true;
};